import { render, staticRenderFns } from "./ed-update-subject-project.component.vue?vue&type=template&id=94faa45c&scoped=true&"
import script from "./ed-update-subject-project.component.ts?vue&type=script&lang=ts&"
export * from "./ed-update-subject-project.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-update-subject-project.component.scss?vue&type=style&index=0&id=94faa45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94faa45c",
  null
  
)

export default component.exports